import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IPlantStorageResponse, ISapConfigResponse, ISapOrderConfigResponse } from "../../types/api/sapConfigApi";
import {
  ISapConfig,
  SapConfigState,
} from "../../types/features/sapConfigSlice";
import {
  getSapConfigQuery,
  getSapOrderConfigQuery,
  getSapPlantStorageQuery,
  updateSapConfigQuery,
} from "../../api/sapConfigApi";

export const getSapConfig = createAsyncThunk<ISapConfigResponse, void>(
  "sapConfig/getSapConfig",
  async () => {
    const response = await getSapConfigQuery();
    return response;
  }
);
export const getSapPlantStorage = createAsyncThunk<
  IPlantStorageResponse,
  { filter: any }
>("sapConfig/getSapPlantStorage", async ({ filter }) => {
  const response = await getSapPlantStorageQuery(filter);
  return response;
});

export const getSapOrderConfig = createAsyncThunk<
  ISapOrderConfigResponse,
  { filter: any }
>("sapConfig/getSapOrderConfig", async ({ filter }) => {
  // console.log(filter,"filter");
  const response = await getSapOrderConfigQuery(filter);
  // console.log(response,"response");
  return response;
});

export const updateSapConfig = createAsyncThunk<
  ISapConfigResponse,
  { data: ISapConfig }
>("sapConfig/updateSapConfig", async ({ data }) => {
  const response = await updateSapConfigQuery(data);
  return response;
});

const SapConfigSlice = createSlice({
  name: "SapConfig",
  initialState: {
    sapConfigLoader: false,
    status: false,
    msg: "",
    data: null,
    sapOrderConfigData: null,
    plantStorageData: null,
  } as SapConfigState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSapConfig.pending, (state) => {
        state.sapConfigLoader = true;
      })
      .addCase(
        getSapConfig.fulfilled,
        (state, action: PayloadAction<ISapConfigResponse>) => {
          // console.log(action.payload, "action.payload.data");
          state.data = action.payload.data;
          state.msg = action.payload.message;
          state.status = true;
          state.sapConfigLoader = false;
        }
      )
      .addCase(getSapConfig.rejected, (state, action) => {
        state.sapConfigLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(updateSapConfig.pending, (state) => {
        state.sapConfigLoader = true;
      })
      .addCase(
        updateSapConfig.fulfilled,
        (state, action: PayloadAction<ISapConfigResponse>) => {
          // console.log(action.payload, "action.payload");
          state.msg = action.payload.message;
          state.status = true;
          state.sapConfigLoader = false;
        }
      )
      .addCase(updateSapConfig.rejected, (state, action) => {
        state.sapConfigLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(getSapOrderConfig.pending, (state) => {
        state.sapConfigLoader = true;
      })
      .addCase(
        getSapOrderConfig.fulfilled,
        (state, action: PayloadAction<ISapOrderConfigResponse>) => {
          // console.log(action.payload, "action.payload");
          if(action.payload.data?.d?.results){

            state.sapOrderConfigData = action.payload.data?.d?.results;
          }
          state.msg = action.payload.message;
          state.status = true;
          state.sapConfigLoader = false;
        }
      )
      .addCase(getSapOrderConfig.rejected, (state, action) => {
        state.sapConfigLoader = false;
        state.status = false;
        state.msg = action.error.message;
      })
      .addCase(getSapPlantStorage.pending, (state) => {
        state.sapConfigLoader = true;
      })
      .addCase(
        getSapPlantStorage.fulfilled,
        (state, action: PayloadAction<IPlantStorageResponse>) => {
          // console.log(action.payload, "action.payload");
          if(action.payload.data?.d?.results){

            state.plantStorageData = action.payload.data?.d?.results;
          }
          state.msg = action.payload.message;
          state.status = true;
          state.sapConfigLoader = false;
        }
      )
      .addCase(getSapPlantStorage.rejected, (state, action) => {
        state.sapConfigLoader = false;
        state.status = false;
        state.msg = action.error.message;
      });
  },
});

export default SapConfigSlice.reducer;
